import { make } from 'vuex-pathify'
import axios from 'axios'
import { getQueryFromFilter, showError } from '@/util/helpers'

const state = {
  paymentMethodSefazList: {
    data: [],
    count: 0,
    limit: 100,
  },
  loading: false,
}

const mutations = make.mutations(state)

const actions = {
  get: async ({ state }, filter = {}) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/paymentMethodSefaz?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.paymentMethodSefazList = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/paymentMethodSefaz/${id}`).catch(showError),
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
